import PotentialVehicleInfoDetailModal from './potential-detail-modal.vue'
export default PotentialVehicleInfoDetailModal
